import { useEffect, useState } from 'react'

import { useSelector } from 'react-redux'

import { initializeWebSocket } from '@driftt/drift-ws'
import { GlobalStore } from '@driftt/traffic-control'

import * as OrgSelectors from 'modules/org/selectors'

export const useDriftWS = () => {
  const [socketSetupComplete, setSocketSetupComplete] = useState<boolean>(false)
  const orgId = useSelector(OrgSelectors.orgId)
  const socket = GlobalStore.getState().socket

  useEffect(() => {
    if (orgId && socket) {
      initializeWebSocket(orgId, GlobalStore)
      setSocketSetupComplete(true)
    }
  }, [orgId, socket])

  return socketSetupComplete
}
